// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__aX01l","load7":"Spinner_load7__tvwIh"};